import React from "react";
import MainMenu from "../components/navigations/MainMenu";

const OurMissions = () => {
  return (
    <div className="relative">
      <div className="absolute top-0 left-0">
        <MainMenu bg="gray-900" />
      </div>
      <div className="pt-20">
        <div className="p-10 flex flex-col justify-center">
          <h1 className="text-2xl font-serif text-center">
            St.John's Vision of Education
          </h1>
          <div>
            <p>
              Our School mission is to ensure and educate the children with the
              ample and the proper socio-cultural and intellectual knowledge, to
              make them responsible citizens and to inspire them to be
              courageous, confident and great to achieve the goals and objective
              of their lives. For the mission, our School will leave
              no-stone-unturned in providing the necessary
              facilities,infrastructures and above all our teacher's commitment
              and concern for their children of God.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurMissions;
